import React from "react";
import { Navigate, Link } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import { useSidebarConfig, isPathDisabled } from "../services/sidebarService";

const AccessDenied = () => (
  <Box sx={{ minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, p: 3 }}>
    <Typography variant="h5" fontWeight={600}>Access denied</Typography>
    <Typography color="text.secondary" textAlign="center">
      This module is not enabled for your account. Contact your administrator if you need it.
    </Typography>
    <Button component={Link} to="/dashboard" variant="contained">Go to dashboard</Button>
  </Box>
);

// Blocks direct-URL access to modules disabled in the sidebar configuration.
// The API enforces the same rule; this just gives a proper page instead of errors.
const ModuleGate = ({ element }) => {
  const cfg = useSidebarConfig();
  if (!cfg.loaded) return null;
  return isPathDisabled(cfg, window.location.pathname) ? <AccessDenied /> : element;
};

const ProtectedRoute = ({ element }) => {
  const token = localStorage.getItem("token");
  const currentPath = window.location.pathname;

  if (!token) {
    if (currentPath.startsWith("/agent")) {
      return <Navigate to="/agent/login" replace />;
    } else if (currentPath.startsWith("/admin")) {
      return <Navigate to="/admin/login" replace />;
    }
    return <Navigate to="/login" replace />;
  }

  if (currentPath.startsWith("/admin") || currentPath.startsWith("/agent")) return element;
  return <ModuleGate element={element} />;
};

export default ProtectedRoute;
